<!DOCTYPE html>
<html lang="pt-br">
<head>
    <meta charset="UTF-8">
    <title>Visão</title>
</head>
<body>
    <section>
        <div class="circle"></div>
        <div class="content">
            <div class="imgBox">
                <img src="https://imgur.com/tgI1dB4.jpg.png"  width="550" height="550" class="imagem">
            </div>
            <div class="textBox mr-5">
                <h2>Visão</h2>
                <br/>
                <p>Consolidar-se dentro do mercado e tornar-se referência para outras redes sociais do mesmo segmento, promovendo um reconhecimento nacional e ampliação do número de usuários dentro da plataforma. </p>                
            </div>
            
            </div>
    </section>
</body>
</html>